<template>
    <div class="col-12 col-sm-6 col-md-6 mt-2" v-if="show && printer">
        <div class="card">
            <div class="card-block header d-flex align-items-center justify-content-between">
                <h4 class="mb-0 card-title d-inline">DI-RS1 </h4>
                <span class="options-icon icon icon-cph_iconset-Kopie_cog pull-right" @click="$emit('open', printer)"></span>
            </div>
            <ul class="list-group list-group-flush mb-0" v-if="media && status">
                <li class="list-group-item">
                    {{$t('PRINTERS.printer')}}
                    {{$t('PRINTERS.ipAddress')}}:
                    {{ip ? ip : $axios.defaults.baseURL}}
                </li>
                <li class="list-group-item">
                    {{$t('PRINTERS.printer')}} {{$t('COMMON.id')}}: {{printer.id}}
                </li>
                <li class="list-group-item">
                    {{$t('PRINTERS.media') | capitalize}}: {{media.media}}"
                    {{$t('PRINTERS.mediaSize') | capitalize}}
                </li>
                <li class="list-group-item">
                    {{$t('PRINTERS.pages') | capitalize}}: {{media.pages}}
                </li>
                <li :class="[
                        'list-group-item card-footer text-center mt-0',
                        status.result === 'ok'
                        || status.code > 0 ? 'bg-success' : 'bg-danger'
                 ]">
                    <span class="text-white">
                        {{$t('PRINTERS.status') | capitalize}}:
                        {{status.result
                        ? status.result
                        : ` code ${status.code}` || capitalize}}
                    </span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script type="text/babel">
import { mapActions } from 'vuex';
import Filters from '../../../../mixins/CphFilters.vue';
export default {
    name: 'PrinterTile',
    data () {
        return {
            status: null,
            media: null,
            pollingFlag: true,
            show: false
        };
    },
    mixins: [Filters],
    props: {
        printer: {
            type: Object,
            required: true,
            polling: {}
        },
        ip: {
            type: String,
            default: ''
        }
    },
    methods: {
        ...mapActions([
            'getPrinterStatus',
            'getPrinterMedia'
        ]),
        async fetchPrinterData () {
            try {
                let [status, media] = await this.$utils.resolvePromises([
                    this. getPrinterStatus(this.ip),
                    this.getPrinterMedia(this.ip)
                ]);
                this.media = media;
                this.status = status[0] || status;
                this.show = true;
                if(this.pollingFlag) {
                    setTimeout(() => this.fetchPrinterData(), 20000);
                }
            } catch (err) {
                throw new Error(err);
            }
        }
    },
    created () {
        this.fetchPrinterData();
    },
    beforeDestroy () {
        this.pollingFlag = false;
    }
};

</script>

<style lang="scss" scoped>
    .card-block.header {
        @include color('background-color', primary);
        @include color('color', text-color-light);
    }
    span.icon.options-icon {
        font-size: 2em;
        cursor: pointer;
    }
</style>
